import React from "react";
import classNames from "classnames";
import { Col, Row, Container } from "reactstrap";
import Link from "../common/Link";
import IconFbSVG from "../svg/icon-fb";
import IconTwSVG from "../svg/icon-tw";
import IconInstagramSVG from "../svg/icon-instagram";
import IconLnSVG from "../svg/icon-ln";
import styles from "./Footer.module.scss";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <Container>
        <Row>
          <Col className={"col-md-3 col-12"}>
            <div className={"d-flex align-items-center h-100"}>
              <Link
                className={styles.logo}
                href={`${i18n.language === "en" ? "/" : "/" + i18n.language}`}
                label="html-description-homepage"
              >
                {/*<img src={`https://assets.radical.storage/static/logo/radical-storage-network-total-white-${i18n.language === 'en' ? 'default' : ''+i18n.language }.svg`}
                                     alt="tml-description-homepage"/>*/}
                <img
                  src={`https://assets.radical.storage/static/logo/radical-storage-network-white-default.svg`}
                  alt="tml-description-homepage"
                />
              </Link>
            </div>
          </Col>
          <Col className={"col-md-6 col-12 d-flex align-items-center"}>
            <div>
              <div className={"d-flex mt-4 mt-md-0 mb-3"}>
                <Link
                  className={styles.link}
                  href={`${
                    i18n.language === "en"
                      ? "/terms-and-conditions-angel"
                      : "/" + i18n.language + "/terms-and-conditions-angel"
                  }`}
                  target="_blank"
                >
                  {t("Terms and Conditions")}
                </Link>
              </div>
              <div
                className={classNames(["d-none d-md-block", styles.copyright])}
              >
                {t(
                  "Radical Storage© - Lean Team S.R.L. - P. IVA 14104111001 - © 2020 Radicalstorage.com. All Rights Reserved"
                )}
              </div>
            </div>
          </Col>
          <Col className={"col-md-3 col-12"}>
            <ul
              className={classNames([
                "d-flex justify-content-md-end justify-content-start align-items-center",
                styles["social-list"],
              ])}
            >
              <li>
                <Link
                  className={"mr-4"}
                  href="https://www.facebook.com/radicalstorage/"
                  label="facebook"
                  target="_blank"
                  data-name="fb"
                >
                  <IconFbSVG />
                </Link>
              </li>
              <li>
                <Link
                  className={"mr-4"}
                  href="https://twitter.com/RadicalStorage"
                  label="twitter"
                  target="_blank"
                  data-name="tw"
                >
                  <IconTwSVG />
                </Link>
              </li>
              <li>
                <Link
                  className={"mr-4"}
                  href="https://www.instagram.com/radicalstorage/"
                  label="instagram"
                  target="_blank"
                  data-name="instagram"
                >
                  <IconInstagramSVG />
                </Link>
              </li>
              <li>
                <Link
                  href="https://www.linkedin.com/company/radicalstorage"
                  label="linkedin"
                  target="_blank"
                  data-name="linkedin"
                >
                  <IconLnSVG />
                </Link>
              </li>
            </ul>
            <div
              className={classNames([
                "text-fs-12 d-block d-md-none",
                styles.copyright,
              ])}
            >
              {t(
                "Radical Storage© - Lean Team S.R.L. - P. IVA 14104111001 - © 2020 Radicalstorage.com. All Rights Reserved"
              )}
            </div>
          </Col>
          <Col className={"col-md-3 col-12"}></Col>
          <Col
            className={
              "col-md-9 col-12 d-flex flex-row flex-wrap justify-content-end "
            }
          >
            <div
              className={classNames([
                "col-12 mt-5",
                styles.footerBottomDivider,
              ])}
            ></div>
            <div
              className={classNames([
                "col-12 pl-0 mt-4 text-fs-12 ",
                styles.copyright,
              ])}
            >
              Radical is also funded by “Vertis Venture 4 Scaleup Lazio”
              investment fund managed by Vertis SGR S.p.A. and backed by:
            </div>
            <div className=" col-12 pl-0 mt-4">
              <img
                className={classNames([styles.footerLogoInvestors])}
                width={"268"}
                height={"35"}
                src={
                  "https://assets.radical.storage/static/logo/logos-investors.png"
                }
                alt={`Radical is also funded by “Vertis Venture 4 Scaleup Lazio” investment fund managed by Vertis SGR S.p.A. and backed by:`}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
